var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_list_0" },
    [
      _c("h4", { staticClass: "_title_0" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "/ticket-vue/ticket/view?ticketType=3&viewId=" + _vm.view.id,
              target: "_blank"
            }
          },
          [_vm._v(_vm._s(_vm.view.name) + "(" + _vm._s(_vm.ticketCount) + ")")]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            "show-header": false,
            data: _vm.ticketList,
            border: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("TicketTitle", {
                      attrs: {
                        ticketTitle: scope.row.orderTitle,
                        ticketNo: scope.row.orderId
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-043e71d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-043e71d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/DashboardTicketTable.vue
// module id = 760
// module chunks = 75